module.exports = __webpack_public_path__ + "static/media/swapIcon.965effd6.svg";